export {default} from '../../../core/components/Repository/ButtonShowMoreInfo';